import { createFileRoute } from '@tanstack/react-router';
import { Contrato } from '@/features/contrato/page/listagem/Contrato';

export const Route = createFileRoute('/a/contrato/')({
    component: Contrato,
});
